import HomeProfileCard from "../HomeProfileCard"

export type PopOverlayProps = {
  userId: string;
  avatarName: string;
  avatarSrc: string;
  name: string;
  bio: string;
  location: string;
  onAddFriendClicked?: () => void;
  addFriendDisabled: boolean;
  requestAccepted: boolean;
  role: string;
  tooltipContent: string;
}
const PopOverlay = ({ userId, avatarName, tooltipContent, role, avatarSrc, name, bio, location, onAddFriendClicked, addFriendDisabled, requestAccepted }: PopOverlayProps): JSX.Element => {
  return <HomeProfileCard tooltipContent={tooltipContent} role={role} avatarSrc={avatarSrc} avatarName={avatarName} name={name} location={location} bio={bio} userId={userId} mode='view' onAddFriendClicked={onAddFriendClicked} addFriendDisabled={addFriendDisabled} requestAccepted={requestAccepted} />
}

export default PopOverlay;